import Decimal from 'decimal.js';

export interface PoolXMoney {
    amount: number;    
    currency: string;    
}

export const sumMoneyAmounts = (...values: (PoolXMoney | undefined | null)[]): string =>
    values.reduce((total, value) => total.plus(String(value?.amount ?? 0)), new Decimal(0)).toString();